import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { APP_ROUTES } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
import { loaderInterceptor } from '@shared/interceptors/loader.interceptor';
import { errorInterceptor } from '@shared/interceptors/error.interceptor';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors([authInterceptor, loaderInterceptor, errorInterceptor])),
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom([NgxDaterangepickerMd.forRoot()])
  ]
};
